<template>
  <div :key="this.declareStat">
    <a-spin :spinning="loading">
      <div class="row">
        <div class="col-6">
          <h5 class="mb-3">
           Final Result settings for class: {{ settingData.name }}
          </h5>
        </div>
        <div class="col-6 text-md-right">
          <a-button
            type="primary"
            icon="file-protect"
            @click="handleDeclare"
            size="small"
            :disabled="this.declareStat !== 0 || !settingsExists ? true : false"
          >
            {{ getDeclaredText() }}
          </a-button>
          <a-button
            type="primary"
            icon="file-protect"
            style="margin-left:5px"
            @click="handleUnDeclare"
            size="small"
            :disabled="this.declareStat !== 0 ? false : true"
          >
            Reset Exam<!-- {{ getDeclaredText() }} -->
          </a-button>
          <a-button
            type="primary"
            icon="eye"
            size="small"
            style="margin-left:5px"
            @click="handleViewFinalReports"
            :disabled="this.declareStat === 1 ? false : true"
          >
            Final Report
          </a-button>
        </div>
        <div class="col-12">
          <div v-if="!settingsExists" class="mb-2">
            <a-tag color="red"
            >No saved settings yet for class: {{ settingData.name }}</a-tag
            >
          </div>
        </div>
      </div>
      <a-divider />
      <a-form class="mb-4" :form="form">
        <div class="col-12">
          <div class="mb-3" v-if="this.schoolExams.length !== 0">
            <!-- Exam -->
            <a-form-item label="School Exams">
              <ul id="navlist">
                <li v-for="(module_data, index) in schoolExams" :key="index">
                  <input
                    type="checkbox"
                    :id="module_data.name"
                    :checked="checked"
                    :value="module_data.id"
                    v-model="examsSelected"
                    @change="getSlNo($event, index)"
                  />
                  <label>{{ module_data.name }}</label>
                  <span class="text-danger"
                  ><b> &nbsp;{{ sl[index] }}</b></span
                  >
                </li>
              </ul>
            </a-form-item>
          </div>
          <div class="mb-3" v-else>
            <p class="text-muted mt-2 mb-1">School Exams</p>
            <span class="text-danger"><b>No exams found !!</b></span>
          </div>
        </div>
        <p class="text-muted mt-2 mb-1">Setup Ranking and Promotion Details</p>
        <a-divider />
        <div class="row">
          <div class="col-md-4">
            <a-form-item label="%score to give rankings upto">
              <a-input-number
                placeholder=""
                v-decorator="[
                  'final_exam_ranking_pc',
                  {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: rankPc
                  }
                ]"
                :min="0"
                :max="100"
                :disabled="false"
                style="width: 100%"
              />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item label="Maximum ranks allowed">
              <a-input-number
                placeholder=""
                v-decorator="[
                  `final_exam_max_rank`,
                  {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: rankMax
                  }
                ]"
                :min="0"
                :max="200"
                :disabled="false"
                style="width: 100%"
              />
            </a-form-item>
          </div>
          <div class="col-md-4 text-md-right" style="padding-top:25px">
            <a-button
              key="submit"
              type="primary"
              icon="save"
              @click="handleSubmit"
              :disabled="this.declareStat === 1 ? true : false"
            >
              Save Setting
            </a-button>
          </div>
        </div>
        <!-- Grade only subject  -->
        <p class="text-muted mt-2 mb-1">Grade only subjects</p>
        <a-divider />
        <div
          class="row justify-content-between py-3"
          v-if="this.finalSettings.length !== 0"
        >
          <!-- section -->
          <div class="col-md-4">
            <a-form-item label="Select Section">
              <a-select
                placeholder="Select a section"
                v-decorator="[
                  'section',
                  {
                    rules: [
                      { required: false, message: 'Please select an option!!' }
                    ],
                    initialValue: getcl_sec.length != null ? getcl_sec[0].id : undefined
                  }
                ]"
                @change="getStudents"
                style="width:200px"
              >
                <a-select-option
                  v-for="sec in getcl_sec"
                  :key="sec.id"
                  :value="sec.id"
                >{{ sec.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-4"></div>
          <div
            class="col-md-4 text-md-right"
            style="padding-top:25px"
            v-if="this.sectionId"
          >
            <bulk-upload-student-mark
              :section="sectionId"
              :className="settingData.name"
              :class_id="classId"
              :sessionId="session"
              :settingId="settingData.final_results_settings[0].id"
              :subjects="gradesSubjectsDetails"
              :declareState="declareStat"
              @created="handleSubjectMarkUpdate"
            />
          </div>
          <div class="col-md-12" v-if="this.studentGrades.length !== 0">
            <a-spin :spinning="loadingTable">
              <table class="table table-bordered table-sm-responsive">
                <thead>
                  <tr>
                    <th>Roll nos</th>
                    <th
                      v-for="sub in gradesSubjectsDetails"
                      :key="sub.id"
                      class="neo-exam-marks-subjects-cell"
                    >
                      <div v-if="declareStat !== 1"
                        class="col"
                        @click="openGradeFormModal(sub.id, sub.name)"
                      >
                        {{ sub.name }}
                      </div>
                      <div v-else
                        class="col"
                      >
                        {{ sub.name }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="std in getclSecStd" :key="std.id">
                  <th scope="row">{{ std.enrollment[0].roll_no }}</th>
                  <th v-for="sub in gradesSubjectsDetails" :key="sub.id">
                    <!-- roll:{{std.enrollment[0].id}}, grade: {{gradesMark.grades}} -->
                    {{ getEnrollIdGrades(std.enrollment[0].id, sub.id) }}
                  </th>
                </tr>
                </tbody>
              </table>
            </a-spin>
          </div>
          <div class="col-md-12" v-else>
            <a-spin :spinning="loadingTable">
              <!-- if grade subject found -->
              <table
                class="table table-bordered table-sm-responsive"
                v-if="this.gradesSubjectsDetails.length !== 0"
              >
                <thead>
                <tr>
                  <th>Roll nos</th>
                  <th
                    v-for="subDetails in gradesSubjectsDetails"
                    :key="subDetails.id"
                    class="neo-exam-marks-subjects-cell"
                  >
                    <div
                      class="col"
                      @click="
                          openGradeFormModal(subDetails.id, subDetails.name)
                        "
                    >
                      {{ subDetails.name }}
                    </div>
                    <!-- <div class="col" @click="openGradeFormModal(subDetails.name)">{{subDetails.name}}</div> -->
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="std in getclSecStd" :key="std.id">
                  <th scope="row">{{ std.enrollment[0].roll_no }}</th>
                  <th v-for="sub in gradesSubjectsDetails" :key="sub.id">
                    <!-- roll:{{std.enrollment[0].id}}, grade: {{gradesMark.grades}} -->
                    --
                  </th>
                </tr>
                </tbody>
              </table>
              <!-- if no grade subject found -->
              <table
                class="table table-sm-responsive"
                v-else
              >
                <tr class="text-center">
                  <b style="color:grey"> ( No grade subjects found! )</b>
                </tr>
              </table>
            </a-spin>
          </div>
        </div>
      </a-form>
    </a-spin>
    <class-exam-marks-form @updated="handleSubjectMarkUpdate" />
  </div>
</template>
<script>
import moment from 'moment'
import ClassExamMarksForm from '@/components/bosemexam/final/Form/GradeSubmit/index'
import BulkUploadStudentMark from '@/components/bosemexam/final/Form/Bulk/index'
import { find } from 'lodash'
export default {
  name: 'FinalResultSettingForm',
  components: {
    ClassExamMarksForm,
    BulkUploadStudentMark,
  },
  props: {
    settingData: {
      type: Object,
      default: () => {},
    },
    session: Number,
    classId: Number,
  },
  mounted: function() {
    this.getClassExams()
    this.getClassSections()
    this.getFinalResultSetting()
    this.getCountNo()
    if (this.settingData.final_results_settings.length !== 0) {
      this.finalSettings = this.settingData.final_results_settings
    } else {
      this.finalSettings = []
    }
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      hover: false,
      settingId: null,
      loading: false,
      selectedClass: null,
      classSections: [],
      getcl_sec: [],
      examResultAsFinal: false,
      examLoading: false,
      classInternalAssessments: [],
      iaLoading: false,
      schoolExams: [],
      subjectLoading: false,
      classExamSubjects: [],
      examIds: [],
      exams: [],
      examSpinning: false,
      checked: true,
      declareStat: 2,
      modules: [],
      value: [],
      examsSelected: [],
      getClassFinalResultSeting: [],
      checkExams: [],
      declare_button_stat: 1,
      rankPc: null,
      rankMax: null,
      sl: [],
      count: 0,
      getclSecStd: [],
      gradesSubjectsDetails: [],
      studentGrades: [],
      showsection: true,
      sectionId: null,
      loadingTable: false,
      finalSettings: [],
    }
  },
  watch: {
    finalSettings: function(value) {
      return value
    },
    loadingTable: function(value) {
      return value
    },
    sectionId: function(value) {
      return value
    },
    settingId: function(value) {
      return value
    },
    studentGrades: function(value) {
      return value
    },
    gradesSubjectsDetails: function(value) {
      return value
    },
    getclSecStd: function(value) {
      return value
    },
    getcl_sec: function(value) {
      return value
    },
    count: function(value) {
      return value
    },
    sl: function(value) {
      return value
    },
    rankPc: function(value) {
      return value
    },
    rankMax: function(value) {
      return value
    },
    examsSelected: function(value) {
      return value
    },
    declareStat: function(value) {
      return value
    },
    declare_button_stat: function(value) {
      return value
    },
    getClassFinalResultSeting: function(value) {
      return value
    },
  },
  computed: {
    settingsExists: function() {
      if (this.settingData.final_results_settings.length !== 0) {
        return true
      } else {
        return false
      }
    },
    commonSetting: function() {
      return find(this.settingData.final_results_settings, { is_unique: 0 })
    },
    getClassId: function() {
      return this.classId
    },
  },
  methods: {
    moment,
    handleSubjectMarkUpdate: function () {
      this.getSubjectGradeDetails()
    },
    openGradeFormModal(subId, name) {
      this.$eventBus.$emit(
        'openClassExamMarksForm',
        subId,
        name,
        this.getclSecStd,
        this.settingData.final_results_settings[0].id,
        this.studentGrades,
        this.getClassId,
        this.session,
        this.examsSelected,
        this.sectionId
      )
    },
    showFirstSection() {
      this.showsection = true
    },
    getEnrollIdGrades(enroll, subId) {
      // this.studentGrades
      let enrollMarkDetails = this.studentGrades.filter(
        obj => obj.enrollment_id === enroll
      )
      if (enrollMarkDetails.length > 0) {
        let subGradeArray = enrollMarkDetails[0].subjectGrades
        let subGradeMark = subGradeArray.filter(
          obj => obj.subject_id === subId
        )
        return subGradeMark[0].grade
      } else {
        return '--'
      }
    },
    getFinalResultSetting() {
      this.loading = true
      this.examsSelected = []
      this.$http
        .get('/api/finalresultsetting', {
          params: {
            class_id: this.getClassId,
          },
        })
        .then(({ data }) => {
          if (this.form.getFieldValue('section') > 0) {
            this.loadingTable = true
            this.getStudents(this.form.getFieldValue('section'))
            this.loadingTable = false
          }
          if (data.data.length !== 0) {
            if (data.data[0].final_results_settings.length !== 0) {
              this.declareStat =
                data.data[0].final_results_settings[0].is_declared
              // this.examsSelected = data.data[0].final_results_settings[0].class_final_report_exams
              if (
                data.data[0].final_results_settings[0].class_final_report_exams
                  .length !== 0
              ) {
                // var e = data.data[0].final_results_settings[0].class_final_report_exams
                data.data[0].final_results_settings[0].class_final_report_exams.forEach(
                  (value, index) => {
                    this.examsSelected.push(value.exam_id)
                  }
                )
              }
              // alert(data.data[0].final_results_settings[0].final_exam_ranking_pc)
              if (
                data.data[0].final_results_settings[0].final_exam_ranking_pc !==
                null &&
                data.data[0].final_results_settings[0].final_exam_max_rank !==
                null
              ) {
                this.rankPc =
                  data.data[0].final_results_settings[0].final_exam_ranking_pc
                this.rankMax =
                  data.data[0].final_results_settings[0].final_exam_max_rank
                // var rankingPc = data.data[0].final_results_settings[0].final_exam_ranking_pc
                // var maxRank = data.data[0].final_results_settings[0].final_exam_max_rank
                this.form.setFieldsValue({
                  final_exam_ranking_pc: this.rankPc,
                })
                this.form.setFieldsValue({
                  final_exam_max_rank: this.rankMax,
                })
              }
            }
          }
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    getStudents(e) {
      this.loading = true
      this.sectionId = e
      this.$http
        .get('/api/student/', {
          params: {
            session_id: this.session,
            class_id: this.getClassId,
            section_id: e,
            limit: 100,
          },
        })
        .then(({ data }) => {
          this.getclSecStd = data.data.sort((a, b) => a.id - b.id)
          this.getSubjectGradeDetails()
          this.loading = false
        })
    },
    getClassSections() {
      this.loading = true
      this.$http
        .get('/api/section/class/' + this.getClassId, {
          params: {
            session_id: this.session,
          },
        })
        .then(({ data }) => {
          // this.loading = false
          this.getcl_sec = data.data
          if (data.data.length !== 0) {
            this.classSections = data.data.map(element => {
              return element.id
            })
          }
          this.loading = false
        })
    },
    getClassExams() {
      this.loading = true
      this.examsSelected = []
      this.schoolExams = []
      this.$http
        .get(`/api/class_common_exams/${this.getClassId}`, {
          params: {
            session_id: this.session,
          },
        })
        .then(({ data }) => {
          this.loading = false
          this.schoolExams = data.data
          // this.examSpinning = false
        })
      this.getCountNo()
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to save?`,
            content: `Click on the OK button to save final result settings!`,
            onOk: () => {
              this.$http
                .post('/api/bosem_final_result_setting', {
                  class_id: this.getClassId,
                  final_exam_ranking_pc: values.final_exam_ranking_pc,
                  final_exam_max_rank: values.final_exam_max_rank,
                  final_exam_consider_failed_subject:
                  values.final_exam_consider_failed_subject,
                  exams: this.examsSelected,
                  // is_declared: 0
                })
                .then(({ data }) => {
                  this.$emit('saved')
                  this.finalSettings = this.settingData.final_results_settings
                  this.getFinalResultSetting()
                  // this.finalSettings = this.settingData.final_results_settings
                  this.finalSettings = data.data

                  this.showsection = false
                  // this.getFinalResultSetting()
                  this.settingId = data.data.id
                  if (data.data.is_declared === 0) {
                    this.declareStat = data.data.is_declared
                  }
                  // this.$emit('saved')
                  this.loading = false
                  this.$notification['success']({
                    message: 'Saved successfully',
                    description: `Final result settings saved successfully!`,
                  })
                  // this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
        this.loading = false
      })
    },
    getSubjectGradeDetails() {
      if (this.settingData.final_results_settings.length !== 0) {
        this.$http
          .get('/api/bosem_final_result_subjects/', {
            params: {
              class_id: this.getClassId,
              section_id: this.sectionId,
              setting_id: this.settingData.final_results_settings[0].id,
              session_id: this.session,
              exams: this.examsSelected,
            },
          })
          .then(({ data }) => {
            this.gradesSubjectsDetails = data.data.gradeOnlySubjects
            this.studentGrades = data.data.enrollmentMarks
          })
      } else {
        this.gradesSubjectsDetails = []
        this.studentGrades = []
      }
    },
    makeFormData(values) {
      // make subjects
      values.class_id = this.getClassId
      // values.exam_result_as_final = this.examResultAsFinal ? 1 : 0
      values.sections = this.classSections

      values.session_id = this.session
      return values
    },
    getDeclaredText: function () {
      if (this.declareStat !== 2) {
        if (this.declareStat === 1) {
          return 'Declared'
        } else if (this.declareStat === 0) {
          return 'Delcare Final'
        }
        // else {
        //   return 'Processing'
        // }
      } else {
        return 'Declare Final'
      }
    },
    handleUnDeclare() {
      this.$confirm({
        title: 'Are you sure?',
        content: h => (
          <div>
            <p class="mb-0">
              Click OK to reset the final exam for the selected class!
            </p>
          </div>
        ),
        onOk: () => {
          this.loading = true
          this.$http
            // .post("/api/declare_final_result/" + this.classId, {
            .post('/api/undeclare_final_result/' + this.getClassId, {
              params: {
                session_id: this.session,
              },
            })
            .then(({ data }) => {
              this.declareStat = 1
              this.loading = false
              this.$notification['info']({
                message: 'Final Result undeclared successfully!',
                // description: `Decleration of final results for the selected class has been started successfully! You will be notified once completed`,
              })
              this.getFinalResultSetting()
            })
            .catch(error => {
              this.loading = false
              this.$neoNotify.error(error)
            })
        },
      })
    },
    handleDeclare: function () {
      this.$confirm({
        title: 'Are you sure?',
        content: h => (
          <div>
            <p class="mb-0">
              Click OK to declare the final exam for the selected class!
            </p>
          </div>
        ),
        onOk: () => {
          this.loading = true
          this.$http
            // .post("/api/declare_final_result/" + this.classId, {
            .post('/api/declare_final_exam/' + this.getClassId, {
              params: {
                session_id: this.session,
              },
            })
            .then(({ data }) => {
              // this.getFinalResultSetting()
              // this.commonSetting.is_declared = 2;
              this.declareStat = 1
              this.loading = false
              this.$notification['info']({
                message: 'Final Result declared successfully!',
                // description: `Decleration of final results for the selected class has been started successfully! You will be notified once completed`,
              })
              this.getFinalResultSetting()
            })
            .catch(error => {
              this.loading = false
              this.$neoNotify.error(error)
            })
        },
      })
    },
    handleViewFinalReports() {
      this.$router.push({
        name: 'finalResultReport',
        params: {
          classId: this.getClassId,
          className: this.settingData.name,
          sessionId: this.session,
        },
      })
    },
    getCountNo() {
      // alert(this.examsSelected.length)
      if (this.examsSelected.length > 0) {
        this.count = this.examsSelected.length
      }
    },
    getSlNo(e, index) {
      // alert(e.target.checked)
      if (e.target.checked === true) {
        this.sl[index] = this.count + 1
        this.count = this.count + 1
        this.sl.splice(index, 1, this.count)
      }
      if (e.target.checked === false) {
        this.removeSlData(this.count, index)
      }
    },
    removeSlData(data, key) {
      var current = this.sl[key]
      this.sl.forEach((item, index) => {
        if (this.sl[key] === item) {
          this.sl.splice(key, 1, null)
          if (this.count > 0) {
            this.count = this.count - 1
          }
        } else {
          if (current !== null) {
            if (item > current && this.sl[key] !== item + 1) {
              this.sl.splice(index, 1, item - 1)
            }
          }
        }
      })
    },
  },
}
</script>
<style>
#navlist li {
  display: inline;
  list-style-type: none;
  padding-right: 20px;
}
input[type="checkbox"] {
  transform: scale(1.3);
  margin-right: 10px;
}
</style>
